import { render, staticRenderFns } from "./arrivelist.vue?vue&type=template&id=3d6772e2"
import script from "./arrivelist.vue?vue&type=script&lang=js"
export * from "./arrivelist.vue?vue&type=script&lang=js"
import style0 from "./arrivelist.vue?vue&type=style&index=0&id=3d6772e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports